//  aws-exports.js
export default {
    "REGION": `${process.env.REACT_APP_COGNITO_REGION}`,
    "USER_POOL_ID": `${process.env.REACT_APP_COGNITO_USER_POOL_ID}`,
    "USER_POOL_APP_CLIENT_ID": `${process.env.REACT_APP_COGNITO_USER_POOL_APP_CLIENT_ID}`
};
